module.exports = __webpack_public_path__ + "img/workflows.62c332b0.svg";